import React from 'react'


class Page extends React.Component {
    render () {
        return (
            <div className='utils__content'>
                {this.props.children}
            </div>
        )
    }
}

export default Page


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Page/index.js